<form #updatePartnerForm="ngForm" class="small-labels" id="{{idString}}">
    <div class="row" *ngIf="data">
        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.partner_name?.visible">
            <label for="{{idString}}-partner_name" class="form-label">CSP Name</label>
            <input type="text" class="form-control form-control-sm" name="partner_name" id="{{idString}}-partner_name"
                [required]="formElemCustomFields?.partner_name?.mandatory"
                [disabled]="formElemCustomFields?.partner_name?.readOnly" [(ngModel)]="data.partner_name"
                #partner_name="ngModel" [pattern]="regExPatterns.nameWithspaceHyphensApostrophesLettersNum">
            <div *ngIf="partner_name.invalid && (partner_name.dirty || partner_name.touched)" class="invalid-feedback">
                <div *ngIf="partner_name.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="partner_name.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.short_name?.visible">
            <label for="{{idString}}-short_name" class="form-label">CSP Short Name</label>
            <input type="text" class="form-control form-control-sm" name="short_name" id="{{idString}}-short_name"
                [required]="formElemCustomFields?.short_name?.mandatory"
                [disabled]="formElemCustomFields?.short_name?.readOnly" [(ngModel)]="data.short_name"
                #short_name="ngModel" [pattern]="regExPatterns.nonWhiteSpaces">
            <div *ngIf="short_name.invalid && (short_name.dirty || short_name.touched)" class="invalid-feedback">
                <div *ngIf="short_name.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="short_name.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.description?.visible">
            <label for="{{idString}}-description" class="form-label">Description</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.description"
                id="{{idString}}-description" name="description"
                [required]="formElemCustomFields?.description?.mandatory"
                [disabled]="formElemCustomFields?.description?.readOnly" #description="ngModel">
            <div *ngIf="description.invalid && (description.dirty || description.touched)" class="invalid-feedback">
                <div *ngIf="description.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.oauth_client_id?.visible">
            <label for="{{idString}}-oauth_client_id" class="form-label">OAuth Client ID</label>
            <input type="text" class="form-control form-control-sm" name="oauth_client_id"
                id="{{idString}}-oauth_client_id" [(ngModel)]="data.oauth_client_id"
                [required]="formElemCustomFields?.oauth_client_id?.mandatory"
                [disabled]="formElemCustomFields?.oauth_client_id?.readOnly" #oauth_client_id="ngModel">
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.oauth_client_secret?.visible">
            <label for="{{idString}}-oauth_client_secret" class="form-label">OAuth Client Secret</label>
            <input type="text" class="form-control form-control-sm" name="oauth_client_secret"
                id="{{idString}}-oauth_client_secret" [(ngModel)]="data.oauth_client_secret"
                [required]="formElemCustomFields?.oauth_client_secret?.mandatory"
                [disabled]="formElemCustomFields?.oauth_client_secret?.readOnly" #oauth_client_secret="ngModel">
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.app_access_level?.visible">
            <label for="{{idString}}-app_access_level" class="form-label">Application Access Level</label>
            <select class="form-select form-select-sm" name="app_access_level" id="{{idString}}-app_access_level"
                [required]="formElemCustomFields?.app_access_level?.mandatory"
                [disabled]="formElemCustomFields?.app_access_level?.readOnly" [(ngModel)]="data.app_access_level"
                #app_access_level="ngModel">
                <option *ngFor="let item of partnerAppAccessLevels">
                    {{item}}
                </option>
            </select>
            <div *ngIf="app_access_level.invalid && (app_access_level.dirty || app_access_level.touched)"
                class="invalid-feedback">
                <div *ngIf="app_access_level.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.api_endpoint?.visible">
            <label for="{{idString}}-api_endpoint" class="form-label">API Endpoint</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.api_endpoint"
                id="{{idString}}-api_endpoint" name="api_endpoint"
                [required]="formElemCustomFields?.api_endpoint?.mandatory"
                [disabled]="formElemCustomFields?.api_endpoint?.readOnly" #api_endpoint="ngModel"
                [pattern]="regExPatterns.urlRegex">
            <div *ngIf="api_endpoint.invalid && (api_endpoint.dirty || api_endpoint.touched)" class="invalid-feedback">
                <div *ngIf="api_endpoint.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="api_endpoint.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.portal_url?.visible">
            <label for="{{idString}}-portal_url" class="form-label">Portal URL</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.portal_url"
                id="{{idString}}-portal_url" name="portal_url" [required]="formElemCustomFields?.portal_url?.mandatory"
                [disabled]="formElemCustomFields?.portal_url?.readOnly" #portal_url="ngModel"
                [pattern]="regExPatterns.urlRegex">
            <div *ngIf="portal_url.invalid && (portal_url.dirty || portal_url.touched)" class="invalid-feedback">
                <div *ngIf="portal_url.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="portal_url.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.registration_status?.visible">
            <label for="{{idString}}-registration_status" class="form-label">Registration Status</label>
            <select class="form-select form-select-sm" name="registration_status" id="{{idString}}-registration_status"
                [required]="formElemCustomFields?.registration_status?.mandatory"
                [disabled]="formElemCustomFields?.registration_status?.readOnly" [(ngModel)]="data.registration_status"
                #registration_status="ngModel">
                <option *ngFor="let item of partnerRegistrationStatuses">
                    {{item}}
                </option>
            </select>
            <div *ngIf="registration_status.invalid && (registration_status.dirty || registration_status.touched)"
                class="invalid-feedback">
                <div *ngIf="registration_status.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.ns_org_id?.visible">
            <label for="{{idString}}-ns_org_id" class="form-label">ORG ID</label>
            <input type="text" class="form-control form-control-sm" name="ns_org_id" id="{{idString}}-ns_org_id"
                [required]="formElemCustomFields?.ns_org_id?.mandatory"
                [disabled]="formElemCustomFields?.ns_org_id?.readOnly" [(ngModel)]="data.ns_org_id"
                #ns_org_id="ngModel">
        </div>

         <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.ns_sdk_enabled?.visible">
            <label for="{{idString}}-ns_sdk_enabled" class="form-label">SDK Enabled</label>
            <select class="form-select form-select-sm" name="ns_sdk_enabled" id="{{idString}}-ns_sdk_enabled"
                [required]="formElemCustomFields?.ns_sdk_enabled?.mandatory"
                [disabled]="formElemCustomFields?.ns_sdk_enabled?.readOnly" [(ngModel)]="data.ns_sdk_enabled"
                #ns_sdk_enabled="ngModel">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
            </select>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.ns_sdk_callback_secret?.visible">
            <label for="{{idString}}-ns_sdk_callback_secret" class="form-label">SDK Callback Secret</label>
            <input type="text" class="form-control form-control-sm" name="ns_sdk_callback_secret"
                id="{{idString}}-ns_sdk_callback_secret" [(ngModel)]="data.ns_sdk_callback_secret"
                [required]="formElemCustomFields?.ns_sdk_callback_secret?.mandatory"
                [disabled]="formElemCustomFields?.ns_sdk_callback_secret?.readOnly" #ns_sdk_callback_secret="ngModel">
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.restrict_mktplace_access?.visible">
            <label for="{{idString}}-restrict_mktplace_access" class="form-label">Restrict Marketplace Access</label>
            <select class="form-select form-select-sm" name="restrict_mktplace_access"
                id="{{idString}}-restrict_mktplace_access"
                [required]="formElemCustomFields?.restrict_mktplace_access?.mandatory"
                [disabled]="formElemCustomFields?.restrict_mktplace_access?.readOnly"
                [(ngModel)]="data.restrict_mktplace_access" #restrict_mktplace_access="ngModel">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
            </select>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.contact_name?.visible">
            <label for="{{idString}}-contact_name" class="form-label">Contact Name</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.contact_name"
                id="{{idString}}-contact_name" name="contact_name"
                [required]="formElemCustomFields?.contact_name?.mandatory"
                [disabled]="formElemCustomFields?.contact_name?.readOnly" #contact_name="ngModel"
                [pattern]="regExPatterns.nameWithspaceHyphensApostrophesLettersNum">
            <div *ngIf="contact_name.invalid && (contact_name.dirty || contact_name.touched)" class="invalid-feedback">
                <div *ngIf="contact_name.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="contact_name.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.contact_email?.visible">
            <label for="{{idString}}-contact_email" class="form-label">Contact Email</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.contact_email"
                id="{{idString}}-contact_email" name="contact_email"
                [required]="formElemCustomFields?.contact_email?.mandatory"
                [disabled]="formElemCustomFields?.contact_email?.readOnly" #contact_email="ngModel"
                [pattern]="regExPatterns.email">
            <div *ngIf="contact_email.invalid && (contact_email.dirty || contact_email.touched)"
                class="invalid-feedback">
                <div *ngIf="contact_email.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="contact_email.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>

        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.contact_num?.visible">
            <label for="{{idString}}-contact_num" class="form-label">Contact Number</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.contact_num"
                id="{{idString}}-contact_num" name="contact_num"
                [required]="formElemCustomFields?.contact_num?.mandatory"
                [disabled]="formElemCustomFields?.contact_num?.readOnly" #contact_num="ngModel"
                [pattern]="regExPatterns.phoneNumberEUS">
            <div *ngIf="contact_num.invalid && (contact_num.dirty || contact_num.touched)" class="invalid-feedback">
                <div *ngIf="contact_num.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
                <div *ngIf="contact_num.errors?.['pattern']">
                    {{errorMsgs.invalidFormat}}
                </div>
            </div>
        </div>

        <div class="mb-3" [ngClass]="columClass" *ngIf="formElemCustomFields?.contact_address?.visible">
            <label for="{{idString}}-contact_address" class="form-label">Contact Address</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="data.contact_address"
                id="{{idString}}-contact_address" name="contact_address"
                [required]="formElemCustomFields?.contact_address?.mandatory"
                [disabled]="formElemCustomFields?.contact_address?.readOnly" #contact_address="ngModel">
            <div *ngIf="contact_address.invalid && (contact_address.dirty || contact_address.touched)"
                class="invalid-feedback">
                <div *ngIf="contact_address.errors?.['required']">
                    {{errorMsgs.required}}
                </div>
            </div>
        </div>
    </div>
</form>